import { render, staticRenderFns } from "./portfolioProject.vue?vue&type=template&id=4f7a91c0&"
import script from "./portfolioProject.vue?vue&type=script&lang=js&"
export * from "./portfolioProject.vue?vue&type=script&lang=js&"
import style0 from "./portfolioProject.vue?vue&type=style&index=0&id=4f7a91c0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports